module.exports = __webpack_public_path__ + "fonts/EuclidFlex-Regular.91686f4.otf";